/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */

import { Component, OnInit, Input, Output , EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { ItemSelectionService } from '../../services/itemselection.service';
import { Categories, ItemSearch , Classification, RequestPriority } from '../../model/itemselectionresponse';
import { ItemTypes } from '../../model/itemselectionresponse';
import { Items } from '../../model/itemselectionresponse';
import { RequestService } from '../../../newrequest/reportincident/services/requestservice';
import { CustomerPreferenceService } from '../../../../preference/customerpreference.service';
import { CustomerPreferenceResponse } from '../../../../preference/customerpreference.model';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/debounceTime';
import { ItemDetailService } from '../../../items/services/itemdetail.service';
import { ItemDetailResponse } from '../../../items/model/itemdetailinfo';
import { ActivatedRoute } from '@angular/router';
import { debounceTime, distinctUntilChanged, switchMap, filter } from 'rxjs/operators';
declare var $: any;


@Component({
  selector: 'zsd-itemselection',
  templateUrl: '../../view/itemselection/itemselection.component.html',
  styleUrls: ['../../view/itemselection/itemselection.component.scss']
})
export class ItemSelectionComponent implements OnInit {

  @Input('parentForm') public parentForm: FormGroup;
  itemSelectionRequired: number;
  arePrioritiesDerived: boolean;
  @Output() private isformValid: EventEmitter<boolean> = new EventEmitter();
  @Input() processIndex: string;
  @Input() fromNewRequestPage;
  @Input() itemId;

  categoryOptions = new Array<Categories>();
  itemTypeOptions = new Array<ItemTypes>();
  itemNameOptions = new Array<Items>();


  itemSelectionForm: FormGroup;
  classificationOptions = new Array<Classification>();
  requestUrgencyOptions = new Array<RequestPriority>();
  priorityString;
  selectedCategory: number;
  selectedType: number;
  selectedItem: number;
  selectedClassification: number;
  selectedUrgency;
  selectedPriority;
  itemSearch = new FormControl();
  itemResultFromSearch: ItemSearch[] = [];
  selectedItemName: string;
  items: Observable<ItemSearch[]>;
  private itemSearchTermSubject: Subject<string> = new Subject();
  itemDetail: ItemDetailResponse = new ItemDetailResponse();
  itemSelected: number;
  showdropDownList = true;
  flagItemNotFound = false;

  // default values
  defaultCategoryString = -1;
  defaultItemTypeString = -1;
  defaultItemNameString = -1;
  isItemLoading = false;

  constructor(public itemSelectionservice: ItemSelectionService, public formBuilder: FormBuilder,
    public incidentService: RequestService, public customerPreferenceService: CustomerPreferenceService,
    public itemDetailService: ItemDetailService, public route: ActivatedRoute) {
    this.selectedCategory = this.defaultCategoryString;
    this.selectedType = this.defaultItemTypeString;
    this.selectedItem = this.defaultItemNameString;
    }

  ngOnInit() {
    this.itemSelectionForm = this.formBuilder.group({
      category: this.formBuilder.control({ value: null }),
      itemType: this.formBuilder.control({ value: null }),
      item: this.formBuilder.control({ value: null }),
      classification: this.formBuilder.control( { value: null }),
      urgency: this.formBuilder.control( { value: null}),
      priority: this.formBuilder.control( { value: null}),
      itemTypeIdforSelectedItem: this.formBuilder.control({ value: null })
    });
    if (this.parentForm) {
      this.parentForm.addControl('itemSelection', this.itemSelectionForm);
      this.parentForm.setControl('itemSelection', this.itemSelectionForm);

    }

    // for item search
    this.itemSearchTermSubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      filter((searchTerm) => (searchTerm.length > 1)),
      switchMap(searchTerm => this.itemSelectionservice.getItemSearch(this.processIndex, searchTerm))
      ).subscribe((resp: ItemSearch[]) => {
          let responseItemSearchFlag = false;
          if (resp.length > 0) {
            responseItemSearchFlag = true;
          }
          if (responseItemSearchFlag) {
            this.flagItemNotFound = false;
            this.showdropDownList = true;
            this.itemResultFromSearch = resp;
          } else {
            this.showdropDownList = false;
            this.flagItemNotFound = true;
            this.itemResultFromSearch = null;
          }
        }
    );
    // fetching categories
    this.itemSelectionservice.getCategories(this.processIndex).subscribe(
      (categories: Categories[]) => {
        this.categoryOptions = categories;
        if (categories.length === 1 && !this.itemSelected) {
          this.selectedCategory = categories[0].categoryId;
          this.fetchItemTypes(categories[0].categoryId);
        }

        // prepopulating popup details when creating request from item detail or service detail
        this.itemSelected = this.itemId;
        if (this.itemSelected) {
          this.setItemDetail();
        }
      },
      err => console.error(err)
    );
      this.customerPreferenceService.getPreferenceList().subscribe(
        (preferences: CustomerPreferenceResponse) => {
          this.itemSelectionRequired = preferences.itemSelectionRequired;
          this.arePrioritiesDerived = preferences.arePrioritiesDerived;
          if (!this.itemSelectionRequired) {
            this.isformValid.emit(true);
          }
        });
    }

  setItemDetail(): void {
    this.itemDetailService.getItemDetail(this.itemSelected).subscribe
    ((itemDetailResponse: ItemDetailResponse) => {
        this.itemDetail = itemDetailResponse;
        this.itemResultFromSearch = null;
        this.selectedItem = this.itemDetail.itemBasicInfo.itemId;
        this.selectedType = this.itemDetail.itemBasicInfo.itemTypeId;
        this.selectedCategory = this.itemDetail.categoryId;
        this.itemSelectionForm.get('category').setValue(this.selectedCategory);

        this.itemSelectionservice.getItemTypes(this.selectedCategory, this.processIndex).subscribe(
          (itemtypes: ItemTypes[]) => {
            this.itemTypeOptions = itemtypes;
            this.itemSelectionForm.get('itemType').setValue(this.selectedType);
            this.itemSelectionservice.getItemID(this.selectedType, this.processIndex).subscribe(
              (items: Items[]) => {
                this.itemNameOptions = items;
                this.itemSelectionForm.get('item').setValue(this.selectedItem);
                this.setItem();
              },
              err => console.error(err)
            );
          },
          err => console.error(err)
        );
        this.setItem();
      });
  }

  searchItem(event: any) {
    this.showdropDownList = true;
    let itemNameSearchTerm = event.target.value;
    if (itemNameSearchTerm == null) {
      this.flagItemNotFound = true;
    }
    this.itemSearchTermSubject.next(itemNameSearchTerm);
    this.flagItemNotFound = false;
    $('.searchList').css('border-bottom', '1px solid #ced4da');
  }

  loadItemDeatilsFromSearch(selectedItem: ItemSearch) {
         this.itemResultFromSearch = null;
         this.itemResultFromSearch = null;
         this.selectedItemName = null;
         this.selectedCategory = selectedItem.itemCategoryId;
         this.itemSelectionForm.get('category').setValue(this.selectedCategory);
        this.itemSelectionservice.getItemTypes(this.selectedCategory, this.processIndex).subscribe(
          (itemtypes: ItemTypes[]) => {
            this.itemTypeOptions = itemtypes;
            this.selectedType = selectedItem.itemTypeId;
            this.itemSelectionservice.getItemID(this.selectedType, this.processIndex).subscribe(
              (items: Items[]) => {
                this.itemNameOptions = items;
                this.selectedItem = selectedItem.itemId;
                this.itemSelectionForm.get('item').setValue(this.selectedItem);
                this.setItem();
              },
              err => console.error(err)
            );
          },
          err => console.error(err)
        );
        this.setItem();

        this.currentSearchItemIndex = -1;
      }
  fetchItemTypes(categoryId: number) {
    this.isItemLoading = false;
    this.showdropDownList = false;
    this.incidentService.applyItemSelection(null);
    if (this.itemSelectionRequired) {
      this.isformValid.emit(false);
    }
    this.itemTypeOptions = [];
    this.itemNameOptions = [];
    this.selectedType = this.defaultItemTypeString;
    this.selectedItem = this.defaultItemNameString;
    this.itemSelectionForm.get('itemType').setValue(this.selectedType);
    this.itemSelectionForm.get('item').setValue(this.selectedItem);
    this.itemSelectionForm.get('category').setValue(this.selectedCategory);
    this.itemSelectionForm.updateValueAndValidity();
    if (this.parentForm) {
      this.parentForm.setControl('itemSelection', this.itemSelectionForm);
    }
    this.itemSelectionservice.getItemTypes(categoryId , this.processIndex).subscribe(
      (itemtypes: ItemTypes[]) => {
        this.itemTypeOptions = itemtypes;
        if (itemtypes.length === 1) {
          this.selectedType = itemtypes[0].itemTypeId;
          this.fetchItems(itemtypes[0].itemTypeId);
        }
      },
      err => console.error(err)
    );
  }

  fetchItems(itemTypeId: number) {
    this.isItemLoading = true;
    this.showdropDownList = false;
    if (this.itemSelectionRequired) {
      this.isformValid.emit(false);
    }
    this.incidentService.applyItemSelection(null);
    this.itemNameOptions = [];
    this.selectedItem = this.defaultItemNameString;
    this.itemSelectionForm.get('item').setValue(this.selectedItem);
    this.itemSelectionForm.get('itemType').setValue(this.selectedType);
    this.itemSelectionForm.updateValueAndValidity();
    this.parentForm.setControl('itemSelection', this.itemSelectionForm);

    this.itemSelectionservice.getItemID(itemTypeId, this.processIndex).subscribe(
      (items: Items[]) => {
        this.itemNameOptions = items;
        this.isItemLoading = false;
        if (items.length === 1) {
          this.selectedItem = items[0].itemId;
          this.setItem();
        }
      },
      err => {
        console.error(err);
        this.isItemLoading = false;
      }
    );
  }

  setItem() {
    this.itemSelectionForm.get('category').setValue(this.selectedCategory);
    this.itemSelectionForm.get('itemType').setValue(this.selectedType);
    this.itemSelectionForm.get('item').setValue(this.selectedItem);
    this.itemSelectionForm.get('itemTypeIdforSelectedItem').setValue(this.selectedType);
    this.itemSelectionForm.updateValueAndValidity();
    this.parentForm.setControl('itemSelection', this.itemSelectionForm);
    if (this.selectedItem !== this.defaultItemNameString) {
      this.incidentService.applyItemSelection(Number(this.selectedType));
      this.isformValid.emit(true);
    } else {
      this.incidentService.applyItemSelection(null);
      if (this.itemSelectionRequired) {
        this.isformValid.emit(false);
    }
  }
  this.showdropDownList = false;
  this.itemSelectionservice.getClassification(this.selectedType).subscribe(
    (classification: Classification[]) => {
        this.classificationOptions = classification;
        for (let i = 0; i < this.classificationOptions.length; i++) {
            if (this.classificationOptions[i].isDefault) {
                this.selectedClassification = this.classificationOptions[i].classificationId;
            }
        }
    },
    err => console.error(err)
);
    this.getUrgenciesList();

this.itemSelectionForm.get('classification').setValue(this.selectedClassification);
this.itemSelectionForm.get('urgency').setValue(this.selectedUrgency);
this.itemSelectionForm.get('priority').setValue(this.selectedUrgency);
}

// if privileges is derived, get urgency list
// if privileges is selected, get priority list
getUrgenciesList() {
    this.itemSelectionservice.getUrgencies()
        .subscribe(
            (urgencies: RequestPriority[]) => {
               // console.log(urgencies);
                this.requestUrgencyOptions = urgencies;
                for (let i = 0; i < this.requestUrgencyOptions.length; i++) {
                    if (this.requestUrgencyOptions[i].isDefault) {
                        this.selectedUrgency = this.requestUrgencyOptions[i].requestPriorityId;
                    }
                }
                if (this.arePrioritiesDerived) {
                    this.getPriorityString();
                }
            }
        );

}

getPriorityString(value?) {
  if (!this.arePrioritiesDerived) {
    this.selectedUrgency = value;
    this.itemSelectionForm.get('priority').setValue(this.selectedUrgency);
}

this.itemSelectionservice.getPriorityBasedOnUrgency(this.selectedItem, this.selectedUrgency)
.subscribe(
    (priority: String) => {
        this.priorityString = priority;
    },
    err => console.error(err)
    );
}

  trackByCatOptions(index) {
    return index;
  }

  trackByTypeOptions(index) {
    return index;
  }

  trackByNameOptions(index) {
    return index;
  }

  currentSearchItemIndex = -1;


  itemSearchListKeyPressAction(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;

    if (charCode === 40) { // Key Down action
      event.preventDefault();
      this.currentSearchItemIndex++;
      if (this.currentSearchItemIndex >= this.itemResultFromSearch.length) {
        this.currentSearchItemIndex = 0;
      }
      let listid = `searchitem${this.currentSearchItemIndex}`;
      let elmnt = document.getElementById(listid);
      elmnt.scrollIntoView(false);
      window.scrollTo(0, 0);
    } else if (charCode === 38) { // Key up action
      event.preventDefault();
      this.currentSearchItemIndex--;
      if (this.currentSearchItemIndex < 0) {
        this.currentSearchItemIndex = (this.itemResultFromSearch.length - 1);
      }
      let listid = `searchitem${this.currentSearchItemIndex}`;
      let elmnt = document.getElementById(listid);
      elmnt.scrollIntoView(false);
      window.scrollTo(0, 0);
    } else if (charCode === 13) { // Enter action
      event.preventDefault();
      document.getElementById('searchitem' + this.currentSearchItemIndex).click();
    } else {
      this.currentSearchItemIndex = -1;
    }

    return true;
  }
}
